import { Button, TextField, Typography } from "@mui/material"
import { Box, Container } from "@mui/system"
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { NavLink } from 'react-router-dom';
import { AuthContext } from "../utils/AuthContext";
import { login } from "../services/AuthController";
import { fetchAppConfig } from "../services/AppConfigService";
import { ConfigContext } from "../utils/ConfigContext";
import { LoadingButton } from "@mui/lab";
import { InputAdornment, IconButton } from "@mui/material";
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();

  const { auth, setAuth } = useContext(AuthContext);
  const { setAppConfig } = useContext(ConfigContext);

  useEffect(() => {
    if (auth.token) {
      handleNavigate();
    }
  }, []);

  function handleNavigate() {
    navigate('/quotation');
  }

  async function handleLogin(event) {
    event.preventDefault();

    if (loading === true) {
      // prevent clicking the button while loading
      return;
    }
    
    // const toastId = toast.loading("Please Wait...");

    try {
      setLoading(true);

      const response = await login({ email, password }).catch(err => {
        setLoading(false);
      });

      const user = response.data.user;
      const token = response.data.token;

      localStorage.setItem('quoting-api-token', token);
      localStorage.setItem('quoting-current-user', JSON.stringify(user));

      setAuth({
        token,
        user
      });

      await handleFetchAppConfig({ token: token }).catch(err => {
        setLoading(false);
      });
      

      setTimeout(() => {
        // toast.update(toastId, {
        //   type: 'success',
        //   render: 'Logged in',
        //   autoClose: 1000,
        //   hideProgressBar: true,
        //   isLoading: false
        // });
  
        setLoading(false);
        handleNavigate();
      }, 200);

    } catch (err) {
      toast.error("Incorrect Email or Password", {
        autoClose: 1000,
        hideProgressBar: true,
      });
    }
  }

  async function handleFetchAppConfig({ token }) {
    const res = await fetchAppConfig({ token: token });

    const config = res.data;

    const configCurrentTimestamp = localStorage.getItem('quoting-app-config-timestamp');

    if (configCurrentTimestamp !== config.timestamp) {
      localStorage.setItem('quoting-app-config-timestamp', config.timestamp);
      localStorage.setItem('quoting-app-config', config.content);

      setAppConfig({
        content: JSON.parse(config.content),
        configTimestamp: config.timestamp
      });
    }
  }


  return (
    <>
      <div className="full-height login-background">
        <div className="login-background-svg">
          <svg width="100%" height="100%" viewBox="0 0 312 296" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
            <g clipPath="url(#clip0_136_1167)">
              <rect width="312" height="296" fill="#eceff1"></rect>
              {/* <rect x="411.414" y="-54.1494" width="60.1952" height="434.579" transform="rotate(29.2605 411.414 -54.1494)" fill="#FEFEFE" fillOpacity="0.1"></rect>
              <rect x="374.309" y="-30.1167" width="79.9891" height="434.579" transform="rotate(29.2605 374.309 -30.1167)" fill="#FEFEFE" fillOpacity="0.1"></rect>
              <rect x="436.414" y="-54.1494" width="60.1952" height="434.579" transform="rotate(29.2605 436.414 -54.1494)" fill="#FEFEFE" fillOpacity="0.1"></rect>
              <rect x="458.861" y="-54.1494" width="60.1952" height="434.579" transform="rotate(29.2605 458.861 -54.1494)" fill="#FEFEFE" fillOpacity="0.1"></rect>
              <rect x="461.556" y="-20.2744" width="50.8837" height="367.355" transform="rotate(29.2605 461.556 -20.2744)" fill="#FEFEFE" fillOpacity="0.1"></rect> */}
            </g>
            <defs>
              <clipPath id="clip0_136_1167">
                <rect width="312" height="296" fill="white"></rect>
              </clipPath>
            </defs>
          </svg>
        </div>
        <Container sx={{ mt: 0, p: '20px 0 28px', boxShadow: 'rgba(0, 0, 0, 0.16) 0px 2px 4px, rgba(0, 0, 0, 0.23) 0px 2px 4px;', pb: 5, position: 'relative', zIndex: 1, backgroundColor: '#fff', borderRadius: 7 }} component="main" maxWidth="xs">
          <Typography align="center">
            <img src={process.env.PUBLIC_URL + "/images/logo.png"} alt="MIB Quote Tool Logo" id="logo" />
          </Typography>
          <Typography sx={{ mt: -7 }} component="h3" variant="h4" align="center">
            Welcome Back!
          </Typography>

          <Box component="form" method="POST" noValidate onSubmit={handleLogin} sx={{ mt: 3 }}>
            <TextField
              sx={{ mt: 2 }}
              required
              fullWidth
              id="email"
              label="Email Address"
              name="email"
              autoComplete="email"
              value={email}
              onChange={(e) => { setEmail(e.target.value) }}
            />

            <TextField
              sx={{ mt: 2 }}
              required
              fullWidth
              id="password"
              label="Password"
              name="password"
              type={showPassword ? "text" : "password"}
              value={password}
              onChange={(e) => { setPassword(e.target.value) }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label={showPassword ? "Hide password" : "Show password"}
                      onClick={() => setShowPassword((show) => !show)}
                      edge="end"
                      tabIndex={-1}
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                )
              }}
            />
            <LoadingButton 
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3 }}
              size="large"
              loadingPosition="start"
              loading={loading}>Login</LoadingButton>
            <Button
              component={NavLink}
              to="/forgot"
              fullWidth
              variant="text"
              sx={{ mt: 2, textTransform: 'none' }}>
              Forgot password?
            </Button>
          </Box>
        </Container>
      </div>
    </>
  )
}

export default Login;